"use client";

import { getWishlistCopy } from "@/content/wishlist-copy";
import { useWishlist } from "@/hooks/use-wishlist";
import { Locale } from "@/i18n-config";
import { WishlistHeartButton } from "@/components/wishlist/wishlist-heart-button";

type CourseWishlistToggleProps = {
  lang: Locale;
  courseSlug: string;
  isAuthenticated: boolean;
  initialWishlistSlugs: string[];
};

export function CourseWishlistToggle({
  lang,
  courseSlug,
  isAuthenticated,
  initialWishlistSlugs,
}: CourseWishlistToggleProps) {
  const copy = getWishlistCopy(lang);
  const wishlist = useWishlist({
    lang,
    isAuthenticated,
    initialSlugs: initialWishlistSlugs,
  });

  return (
    <WishlistHeartButton
      courseSlug={courseSlug}
      isWished={wishlist.isWished(courseSlug)}
      size="md"
      variant="inline"
      disabled={wishlist.isPending(courseSlug)}
      addAriaLabel={copy.addAria}
      removeAriaLabel={copy.removeAria}
      onToggle={(slug) => {
        void wishlist.toggle(slug);
      }}
    />
  );
}
